import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, catchError, throwError, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth-service';
import { ApiErrorResponse } from '../../pages/admin-dashboard/partially-package-reasons/reasons-delete/reasons-delete.model';

@Injectable({
  providedIn: 'root',
})
export class PPReasonDeleteService {
  private http = inject(HttpClient);
  private authService = inject(AuthService);

  private readonly API = environment.pharmacyMgtApiUrl;
  private readonly ENDPOINT = `${this.API}/orders/partially/package/reasons`;

  private getAuthHeaders(): HttpHeaders {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  }

  deleteReason(reasonId: number): Observable<void> {
    const headers = this.getAuthHeaders();
    return this.http.delete<void>(`${this.ENDPOINT}/${reasonId}`, { headers }).pipe(
      tap(() => console.log(`Reason ${reasonId} deleted successfully`)),
      catchError(this.handleError),
    );
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    const apiError: ApiErrorResponse = error.error;
    return throwError(() => apiError);
  }
}
